import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material';
import { combineLatest } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { Constants } from 'src/app/shared';
import { Location } from '@angular/common';

@Component({
  selector: 'app-solar-dashboard',
  templateUrl: './solar-dashboard.component.html',
  styleUrls: ['./solar-dashboard.component.scss']
})
export class SolarDashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('tabs') tabs: MatTabGroup;
  isEdit = true;
  items: any;
  siteId: string;
  activeTabIndex = 0;
  PER_SOLAR_PLANT_OVERVIEW = true;
  PER_SOLAR_INVERTER_VIEW = true;
  PER_SOLAR_ARCHITECTURE_VIEW = true;
  PER_NOTIFICATIONS = true;
  lineManagementTabs = [];
  constructor(private router: Router, private activeRoute: ActivatedRoute, private location: Location,
    private authService: AuthService) {
    this.PER_SOLAR_PLANT_OVERVIEW = authService.doAuthorization([Constants.ACTIVITY.SOLAR_PLANT_OVERVIEW]);
    this.PER_SOLAR_INVERTER_VIEW = authService.doAuthorization([Constants.ACTIVITY.SOLAR_INVERTER_VIEW]);
    this.PER_SOLAR_ARCHITECTURE_VIEW = authService.doAuthorization([Constants.ACTIVITY.SOLAR_ARCHITECTURE_VIEW]);
    this.PER_NOTIFICATIONS = authService.doAuthorization([Constants.ACTIVITY.NOTIFICATIONS]);


    this.lineManagementTabs = [
      {
        id:'plant-view-id',
        label: 'Plant OverView',
        path: 'plant-view',
        disable: !this.PER_SOLAR_PLANT_OVERVIEW
      },
      {
        id:'inverter-view-id',
        label: 'Inverter View',
        path: 'inverter-view',
        disable: !this.PER_SOLAR_INVERTER_VIEW
      },
      {
        id:'architecture-id',
        label: 'Architecture',
        path: 'architecture',
        disable: !this.PER_SOLAR_ARCHITECTURE_VIEW
      },
      {
        id:'solar-notification-id',
        label: 'Notifications',
        path: 'notification',
        disable: !this.PER_NOTIFICATIONS
      }
    ];
  }

  ngOnInit() {
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    
    // Subscribe to the single observable, giving us both
    urlParams.subscribe(routeParams => {
      this.siteId = routeParams.siteId;
    });

    // Update selected tab base on URL - In case user use Back - Next button on browser.
    this.location.subscribe(() => {
      let currentLocation = this.location.path(true);
      if (currentLocation && currentLocation.indexOf('/site/solar-dashboard/') >= 0) {
        currentLocation = currentLocation.replace('/site/solar-dashboard/', '');
        currentLocation = currentLocation.substr(0, currentLocation.indexOf('?'));

        if (currentLocation && currentLocation.length > 0) {
          for (let i = 0; i < this.lineManagementTabs.length; i++) {
            if (this.lineManagementTabs[i].path === currentLocation) {
              this.activeTabIndex = i;
              break;
            }
          }
        }
      }
    });
  }

  ngOnDestroy() {
    // Setting selected line to null when navigating away from edit mode.
  }
  navigate($event: MatTabChangeEvent) {
    const tab = this.lineManagementTabs[$event.index];
    this.router.navigate(['site/solar-dashboard/', tab.path], { queryParams: { siteId: this.siteId , alertType:"Solar"} });
  }

  ngAfterViewInit() {
    this.router.navigate(['site/solar-dashboard', 'plant-view'], { queryParams: { siteId: this.siteId } });
  }

}
